<mic-spinner-overlay ariaLabel="In Progress" color="primary" [loading]="loading">
  <div class="page-container">
    <div class="page-title-section">
      <h1><mat-icon>map</mat-icon> Gestão de Territórios</h1>
      <p class="page-subtitle">Gerencie os territórios e atribuições de distribuidores</p>
    </div>

    <!-- Filters -->
    <div class="filter-section">
      <div class="filter-header">
        <mat-icon>tune</mat-icon>
        Filtros de Pesquisa
      </div>
      <div class="filter-body">
        <form [formGroup]="filterForm">
          <div class="filter-grid cols-3">
          <app-select-form-field label="LB" [control]="productLine" [options]="productLines"
            [display]="productLineDisplayName" />
          <app-select-form-field label="Estado" [control]="state" [options]="states"
            [display]="stateDisplayName" />
          <app-select-form-field label="Cidade" [control]="city" [options]="cities"
            [display]="cityDisplayName" />
          </div>
        </form>
      </div>
      <div class="filter-footer">
        <div class="filter-footer-left">
          <button mat-flat-button color="accent" class="mic-btn-icon-left" (click)="applyFilter()">
            <mat-icon>search</mat-icon><span>Buscar</span>
          </button>
          <button mat-stroked-button color="primary" class="mic-btn-icon-left" (click)="resetFilter()">
            <mat-icon>refresh</mat-icon><span>Limpar</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Actions -->
    @if (selection.length > 0) {
      <div class="actions-bar">
        <div class="actions-right">
          <button mat-flat-button color="primary" class="mic-btn-icon-left" (click)="onUpdateClick()">
            <mat-icon>border_color</mat-icon><span>Alterar</span>
          </button>
          <button mat-flat-button color="warn" class="mic-btn-icon-left" (click)="onRemoveClick()">
            <mat-icon>backspace</mat-icon><span>Remover Distribuidor</span>
          </button>
        </div>
      </div>
    }

    <!-- Table -->
    <div class="table-section">
      <mic-table [config]="cityTableConfig" [dataSource]="dataSource">
        <ng-container *micCellTemplate="let item; name: 'distributorCell'">
          <span [style.color]="item.distributorId ? '#000' : 'red'">{{ item.distributorName || 'Não definido' }}</span>
        </ng-container>
      </mic-table>
    </div>
  </div>
</mic-spinner-overlay>

<mic-modal #updateModal (result)="onUpdateModalClosed($event)"></mic-modal>
<ng-template #updateModalContent>
  <p class="mb-4">Selecione o distribuidor exclusivo para as cidades selecionadas:</p>
  <div class="flex flex-col gap-4" [formGroup]="attributeForm">
    <app-select-form-field label="Distribuidor Exclusivo" [control]="attributeDistributor" [options]="distributors"
      [display]="distributorDisplayName" />
    <mat-form-field>
      <mat-label>Tipo de Preço</mat-label>
      <input matInput formControlName="priceType">
    </mat-form-field>
  </div>
</ng-template>

<mic-modal #removeModal (result)="onRemoveModalClosed($event)"></mic-modal>
<ng-template #removeModalContent>
  Deseja remover os distribuidores exclusivos das cidades selecionadas?
</ng-template>